const Intro3 = () => {
  return (
    <div className="intro-content">
      <h1 className="intro-content__title">تجمیع، پایش و تحلیل اطلاعات</h1>

      <p className="u-margin-bottom-small-1-5">
      با استفاده از اسکن کد هر واحد صنفی و بخش اصناف این سامانه ها میتوانید وضعیت سلامت واحد صنفی مورد نظر خود را بررسی فرمایید و با آگاهی کامل از وضعیت سلامتی هریک از افراد شاغل در واحد صنفی، اقدام به مراجعه به آن واحد صنفی فرمایید
      </p>
      <ul>
        <li>
          <i></i>
          استعلام وضعیت فعالیت هر واحد صنفی
        </li>
        <li>
          <i></i>
          استعلام وضعیت سلامت افراد شاغل در هر واحد صنفی
        </li>
        <li>
          <i></i>
          مشاهده دستورالعمل های مربوط به هر واحد صنفی
        </li>
      </ul>
    </div>
  );
}

export default Intro3;